import { LitElement, html } from 'lit';
import { API_ENDPOINT } from '../constants';

export class UserOrders extends LitElement {
  static properties = {
    pendingOrders: { type: Array },
    fulfilledOrders: { type: Array },
    loading: { type: Boolean },
  };

  constructor() {
    super();
    this.pendingOrders = [];
    this.fulfilledOrders = [];
    this.loading = true;
  }

  createRenderRoot() {
    return this; // Use light DOM for Tailwind styling
  }

  async connectedCallback() {
    super.connectedCallback();
    this.loading = true;
    try {
      const [pendingRes, fulfilledRes] = await Promise.all([
        fetch(`${API_ENDPOINT}/user/pending-orders`, { credentials: 'include' }),
        fetch(`${API_ENDPOINT}/user/fulfilled-orders`, { credentials: 'include' }),
      ]);

      if (pendingRes.ok) this.pendingOrders = await pendingRes.json();
      if (fulfilledRes.ok) this.fulfilledOrders = await fulfilledRes.json();
    } catch (err) {
      console.error('Error fetching orders:', err);
    }
    this.loading = false;
  }

  renderContent(url: string) {
    if (url.match(/\.(mp4|webm|mov)$/i)) {
      return html`<video class="w-full rounded-lg shadow" controls src="${url}"></video>`;
    }
    return html`<img class="w-full rounded-lg shadow" src="${url}" alt="Order Content" />`;
  }

  render() {
    return html`
      <!-- Call to Action -->
      <div class="mb-8 text-center">
        <h1 class="text-2xl font-bold mb-2">${__Lang__.orders_cta_title}</h1>
        <p class="text-base-content/70 text-sm mb-4">${__Lang__.orders_cta_subtitle}</p>
        <a href="/shop" class="btn btn-accent btn-sm ">${__Lang__.orders_cta_button}</a>
      </div>

      ${this.loading ? html`<p class="text-sm opacity-70">${__Lang__.orders_loading}</p>` : html`
        <div class="space-y-10">
          <!-- Pending Orders -->
            ${this.pendingOrders.length > 0 ? html`
          <section>
            <h2 class="text-xl font-semibold mb-2">${__Lang__.orders_pending_title}</h2>
              <ul class="grid gap-4">
                ${this.pendingOrders.map(order => html`
                  <li class="card bg-base-200 p-4 shadow">
                    <p class="text-sm">${__Lang__.orders_product_id}: ${order.product_id}</p>
                    <p class="text-sm">${__Lang__.orders_points}: ${order.points} pts</p>
                    <p class="text-xs text-base-content/70">${new Date(order.created_at).toLocaleString()}</p>
                  </li>
                `)}
              </ul>
          </section>
            ` : null}

          <!-- Fulfilled Orders -->
          <section>
            <h2 class="text-xl font-semibold mb-2">${__Lang__.orders_fulfilled_title}</h2>
            ${this.fulfilledOrders.length > 0 ? html`
              <ul class="grid gap-6">
                ${this.fulfilledOrders.map(order => html`
                  <li class="card bg-base-100 p-4 shadow-lg">
                    <p class="font-semibold text-center bg-secondary text-primary-content px-4 py-3 rounded-xl shadow-md mb-4">
                      <span class="text-sm block">${__Lang__.orders_message}:</span> <span class="text-lg">"${order.message}"</span>
                    </p>
                    ${this.renderContent(order.content_url)}
                    <p class="text-xs text-base-content/60 mt-2">${__Lang__.orders_fulfilled_on}: ${new Date(order.fulfilled_at).toLocaleString()}</p>
                  </li>
                `)}
              </ul>
            ` : html`<p class="text-base-content/70 text-sm">${__Lang__.orders_none_fulfilled}</p>`}
          </section>
        </div>
      `}
    `;
  }
}

customElements.define('user-orders', UserOrders);

